export default __webpack_public_path__ + "static/media/1-13@2x.9a856221.png";